import { render, staticRenderFns } from "./china-map.vue?vue&type=template&id=d76c06aa&scoped=true&"
import script from "./china-map.vue?vue&type=script&lang=js&"
export * from "./china-map.vue?vue&type=script&lang=js&"
import style0 from "./china-map.vue?vue&type=style&index=0&id=d76c06aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76c06aa",
  null
  
)

export default component.exports